import { clsx } from 'clsx'
import { memo } from 'react'

import type { WheelItem } from './wheelData'

type Props = {
  d: string
  item: WheelItem
  color: string
  isActive: boolean
  itemOnSelect: (item: WheelItem) => void
  isSearching: boolean
  isFound: boolean
}

export default memo(function WheelSection({
  d,
  item,
  color,
  isActive,
  itemOnSelect,
  isSearching,
  isFound,
}: Props) {
  return (
    <path
      d={d}
      onClick={() => itemOnSelect(item)}
      className={clsx(
        isActive ? 'fill-violet-800/80' : color,
        isSearching && isFound ? 'opacity-100' : 'opacity-40',
        !isSearching && 'opacity-100',
        'transition-colors hover:opacity-70',
      )}
    />
  )
})
